import React, { useState, useEffect } from "react"
import { AuthActions } from "redux-store/models"
import { connect } from "react-redux"
import Step0 from "./Step0"
import NewStep1 from "./NewStep1"
import NewStep2 from "./NewStep2"
import NewStep3 from "./NewStep3"
import axios from "axios"
import { endpoint } from "../../../config/api"
import { notification } from "antd"

const AdminLoginSkins = ({
  skinList,
  addEditSkinDetails,
  addEditSkin,
  accountInfo,
}) => {
  const token = accountInfo?.token

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      if (addEditSkin.skinId === -1) {
        const response = await axios.post(
          `${endpoint}skins`,
          {
            ...addEditSkin.step1,
            ...addEditSkin.step2,
            ...addEditSkin.step3,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        if (response?.data?.message) {
          notification["success"]({
            message: response?.data?.message,
          })
        }
      } else {
        const response = await axios.post(
          `${endpoint}edit-skin/${addEditSkin.skinId}`,
          {
            // ...addEditSkin.changedValues,
            ...addEditSkin.step1,
            ...addEditSkin.step2,
            ...addEditSkin.step3,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )

        if (response?.data?.message) {
          notification["success"]({
            message: response?.data?.message,
          })
        }
      }
    } catch (err) {
      console.error("Error:", err)

      const { response } = err

      if (!response) {
        notification["error"]({
          message: "Unexpected error occurred.",
        })
        return
      }

      const { data } = response

      if (data?.errors) {
        const errors = data.errors

        const errorFields = Object.keys(errors)
        const stepNumber = errorFields
          .map(getStepForField)
          .find((step) => step !== null)

        addEditSkinDetails({
          ...addEditSkin,
          errors,
          ...(stepNumber !== null ? { stepNumber } : {}),
        })

        console.log("Set Errors:", errors)

        if (stepNumber === null) {
          console.error("None of the fields found in any step")
        }
      } else if (data?.message) {
        notification["error"]({
          message: data.message,
        })
      } else {
        notification["error"]({
          message: "An unknown error occurred.",
        })
      }
    }
  }

  const getStepForField = (field) => {
    if (addEditSkin.step1 && field in addEditSkin.step1) {
      return 1
    } else if (addEditSkin.step2 && field in addEditSkin.step2) {
      return 2
    } else if (addEditSkin.step3 && field in addEditSkin.step3) {
      return 3
    } else {
      console.log("Field not found in any step")
      return null
    }
  }

  useEffect(() => {
    addEditSkinDetails({
      step1: {},
      step2: {},
      step3: {},
      stepNumber: 0,
      errors: {},
    })
  }, [])

  return (
    <>
      {addEditSkin?.stepNumber === 1 ? (
        <NewStep1 key={1} />
      ) : addEditSkin?.stepNumber === 2 ? (
        <NewStep2 key={2} />
      ) : addEditSkin?.stepNumber === 3 ? (
        <NewStep3 key={3} handleSubmit={handleSubmit} />
      ) : (
        <Step0 skinList={skinList} addEditSkinDetails={addEditSkinDetails} />
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    addEditSkin: state.auth.addEditSkin,
    accountInfo: state.auth.accountInfo,
  }
}

export default connect(mapStateToProps, AuthActions)(AdminLoginSkins)
